<script>
	export let block;
	export let data;
	export let index;
	export let j;
	export let type = "";

	import {
		saved,
		changed,
		isNewDataChanged,
	} from "../../../../../stores/variables";
	import { cloneDeep } from "lodash-es";

	let opened;

	$: if ($saved) {
		if ($saved === "saved") {
			if (
				data[data.field_name] &&
				data[data.field_name][index] &&
				data[data.field_name][index].active
			) {
				opened = false;
				$isNewDataChanged = true;

				block.value = "";
				block.raws.forEach((raw) => {
					if (!block.value) block.value = raw.exitValue;
					else {
						block.value = block.value + "^^^" + raw.exitValue;
					}
					// if (block.value == "" && raw.exitValue == "") {
					// } else {
					// block.value = block.value + "^^^" + raw.exitValue;
					// }
				});

				block.newData[block.field_name] = block.value;
				data[data.field_name][index][j] = block;
				data.loadedData[index][block.field_name] = block.value;
				data.loadedData[index]["toUpdate"] = true;

				if (data.newData[data.field_name].length < 1) {
					data.newData[data.field_name].push(data.loadedData[index]);
				} else {
					let check = false;
					data.newData[data.field_name].forEach((new_sp) => {
						if (new_sp["ID"] == data.loadedData[index]["ID"])
							check = true;
					});
					if (!check) {
						data.newData[data.field_name].push(
							data.loadedData[index]
						);
						check = false;
					}
				}
			}
			if (
				data[data.field_name + "_new"] &&
				data[data.field_name + "_new"][index] &&
				data[data.field_name + "_new"][index].active
			) {
				$isNewDataChanged = true;

				block.value = "";
				block.raws.forEach((raw) => {
					if (!block.value) block.value = raw.exitValue;
					else {
						block.value = block.value + "^^^" + raw.exitValue;
					}
					// if (block.value == "" && raw.exitValue == "") {
					// } else {
					// block.value = block.value + "^^^" + raw.exitValue;
					// }
				});

				if (block.value) {
					block.newData[block.field_name] = block.value;
					data.createdData[index][block.field_name] = block.value;
				} else {
					block.newData[block.field_name] = "";
					data.createdData[index][block.field_name] = "";
				}
				data[data.field_name + "_new"][index][j] = block;
				if (data.newData[data.field_name].length < 1) {
					data.newData[data.field_name].push(data.createdData[index]);
				} else {
					let check = false;
					data.newData[data.field_name].forEach((new_sp) => {
						if (new_sp.temp_id == data.createdData[index].temp_id)
							check = true;
					});
					if (!check) {
						data.newData[data.field_name].push(
							data.createdData[index]
						);
						check = false;
					}
				}
			}
		}
		if ($saved === "canceled") {
			block.value = block.before.value;
			block.raws = block.before.raws;
			block.newData[block.field_name] = block.before.value;
			// if (block.value == block.upl_value) {
			// 	$isNewDataChanged = false;
			// }
			opened = false;
		}
	}

	if (!block.newData) block.newData = [];
	if (!block.value) block.value = "";
	if (!block.raws) block.raws = [];

	if (block.newData && block.raws == "") {
		block.value = block.newData[block.field_name];
		block.upl_value = cloneDeep(block.value);
		if (block.value) {
			block.value.split("^^^").forEach((raw) => {
				let temp = {};
				temp.date1 = raw.split("|||")[0];
				temp.value = raw.split("|||")[1];
				block.raws.push(temp);
			});
		}
	}

	if (block.raws == "") {
		block.raws = [
			{
				date1: "",
				value: "",
			},
		];
	}

	function add() {
		block.raws = block.raws.concat({
			date1: "",
			value: "",
		});
	}
	function remove(i) {
		$isNewDataChanged = true;
		block.raws.splice(i, 1);
		block.raws = block.raws;
	}

	$: if (block) {
		block.raws.forEach((raw) => {
			if (raw["date1"] || raw["value"]) {
				raw.exitValue = raw["date1"] + "|||" + raw["value"];
			} else {
				raw.exitValue = "";
			}
		});
	}

	$: if (!opened) {
		opened = "1";
		if (!block.before) block.before = {};
		block.before.value = cloneDeep(block.value);
		block.before.raws = cloneDeep(block.raws);
	}
</script>

{#if block}
	<div class="modal__item-name">
		<span class="modal__item-name-text">{block.name ? block.name : ""}</span
		>
		<span class="multiple__add" on:click={() => add()}
			><i class="fas fa-times" /></span
		>
	</div>

	{#if block.raws}
		<div class="multiple">
			{#each block.raws as raw, i}
				<div>
					<input
						class="multiple__date"
						type="text"
						on:input={(e) => {
							e.target.value = e.target.value.replace(
								/[^\d.]/g,
								""
							);
						}}
						maxlength={4}
						bind:value={raw.date1}
						placeholder={block.date1_placeholder
							? block.date1_placeholder
							: "Год"}
					/>
					<input
						class="multiple__value"
						type="text"
						bind:value={raw.value}
						placeholder={block.value_placeholder
							? block.value_placeholder
							: "Название"}
					/>
					{#if block.raws.length > 1}
						<span
							class="multiple__remove"
							on:click={() => remove(i)}
							><i class="fas fa-times " /></span
						>
					{/if}
				</div>
			{/each}
		</div>
	{/if}
{/if}

<style lang="scss">
	.multiple {
		display: flex;
		flex-direction: column;
		width: 100%;

		&__add {
			display: flex;
			flex-shrink: 0;
			font-size: 24px;
			margin-left: auto;
			color: var(--color-1);
			cursor: pointer;
			align-self: flex-end;
			margin-bottom: 53px;
			> i {
				transform: rotate(45deg);
			}
		}
		&__remove {
			display: flex;
			flex-shrink: 0;
			font-size: 24px;
			margin-left: auto;
			color: var(--color-1);
			cursor: pointer;
			order: 4;
			width: 100%;
			max-width: 10%;
			align-items: center;
			justify-content: center;
		}

		input {
			outline: none;
		}

		&__date {
			display: flex;
			width: 100%;
			max-width: 40%;
			padding: 18px 20px;
			font-size: 16px;
			order: 1;
			border: 0;
			border-right: 1px solid #eaebf2;
			&::placeholder {
				font-size: 13px;
			}
		}

		&__value {
			display: flex;
			flex-grow: 1;
			padding: 18px 20px;
			font-size: 16px;
			order: 5;
			width: 100%;
			border: 0;
			border-top: 1px solid #eaebf2;
			border-right: 1px solid #eaebf2;
		}
		> div {
			display: flex;
			flex-wrap: wrap;
			border-top: 1px solid #eaebf2;

			&:first-child {
				border: none;
			}
		}

		@media (max-width: 767px) {
			&__add {
				position: absolute;
				z-index: 1;
				width: 100%;
				max-width: 15%;
				bottom: 56px;
				right: 15%;
				display: flex;
				align-items: center;
				justify-content: center;
				height: 55px;
				margin-bottom: 0;
			}
			&__remove {
				max-width: 15%;
			}
			&__date {
				max-width: 35%;
			}
			&__value {
				border: 0 !important;
				border-top: 1px solid #eaebf2 !important;
			}
		}
	}
</style>
